import { useEffect, useState } from 'react';

const VIEWER_BONE_HOVER_EVENT = 'cartographer:viewer-bone-hover';

interface ViewerBoneHoverDetail {
  boneName: string | null;
}

export function dispatchViewerBoneHoverName(boneName: string | null) {
  if (typeof window === 'undefined') return;

  window.dispatchEvent(
    new CustomEvent<ViewerBoneHoverDetail>(VIEWER_BONE_HOVER_EVENT, {
      detail: { boneName },
    }),
  );
}

export function useViewerHoveredBoneName() {
  const [hoveredBoneName, setHoveredBoneName] = useState<string | null>(null);

  useEffect(() => {
    const handleViewerBoneHover = (event: Event) => {
      const customEvent = event as CustomEvent<ViewerBoneHoverDetail>;
      setHoveredBoneName(customEvent.detail?.boneName ?? null);
    };

    window.addEventListener(VIEWER_BONE_HOVER_EVENT, handleViewerBoneHover);
    return () => {
      window.removeEventListener(VIEWER_BONE_HOVER_EVENT, handleViewerBoneHover);
    };
  }, []);

  return hoveredBoneName;
}
